import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container px-4 mx-auto text-left pt-10 lg:pb-10 flex justify-center items-start" }
const _hoisted_2 = { class: "w-full lg:w-2/3 xl:w-1/2 mt-8" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Podaj poniżej swój adres e-mail, na który wyślemy wiadomość z indywidualnym linkiem, pozwalającym kontynuować zmianę hasła. ")
const _hoisted_4 = { class: "my-8 grid sm:grid-cols-2 gap-4" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Odzyskaj dostęp ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Powrót ")
const _hoisted_7 = { class: "text-center text-sm" }

import { ref } from 'vue'
import { UiButton, UiHeading, UiInput, UiTitle } from '@/components/common/ui'
import { useAuth } from '@/composables/useAuth'
import { useRouter } from 'vue-router'
import { useNotifications } from '@/composables/useNotifications'
import { Form } from 'vee-validate'
import * as Yup from 'yup'
import { ButtonTypes } from '@/types/enums/button'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { resetPassword, loading } = useAuth()
const router = useRouter()
const { pushFail, pushSuccess } = useNotifications()

const email = ref<string>('')
const version = ref<string>(`v${process.env.PACKAGE_VERSION}`)
const handleBack = () => {
    router.push({ name: 'login' })
}
const handleResetPassword = async () => {
    try {
        await resetPassword(email.value)
        pushSuccess('Wysłaliśmy link do resetu hasła na Twój adres email.')
    } catch (error) {
        if (error instanceof Error) {
            pushFail(error.message)
        }
    }
}
const schema = Yup.object().shape({
    email: Yup.string()
        .email()
        .required(),
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(UiHeading), { title: "Reset hasła" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(Form), {
          "validation-schema": _unref(schema),
          onSubmit: handleResetPassword
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(UiTitle), { class: "mb-8" }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_unref(UiInput), {
              modelValue: email.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
              placeholder: "Adres e-mail",
              "input-name": "email"
            }, null, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_unref(UiButton), {
                loading: _unref(loading),
                primary: ""
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }, 8, ["loading"]),
              _createVNode(_unref(UiButton), {
                type: _unref(ButtonTypes).BUTTON,
                onClick: handleBack
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }, 8, ["type"])
            ])
          ]),
          _: 1
        }, 8, ["validation-schema"]),
        _createElementVNode("div", _hoisted_7, _toDisplayString(version.value), 1)
      ])
    ])
  ], 64))
}
}

})